import { channels, type ChannelItem } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import { ChannelIcon, type ChannelIconId } from '@/components/ChannelIcons';
import './Channels.css';

function ChannelCard({ item, compact = false }: { item: ChannelItem; compact?: boolean }) {
  return (
    <li className={compact ? 'channel-card channel-card--compact' : 'channel-card'}>
      <div className="channel-card__icon" aria-hidden>
        <ChannelIcon id={item.id as ChannelIconId} size={compact ? 36 : 44} />
      </div>
      <div className="channel-card__text">
        <span className="channel-card__name">{item.name}</span>
        {item.detail ? <span className="channel-card__detail">{item.detail}</span> : null}
      </div>
    </li>
  );
}

export function Channels() {
  return (
    <Section id="canales" label="Multicanal" title={channels.title} lead={channels.lead}>
      <ScrollReveal>
        <p className="channels-kicker">Canales listos para operar</p>
        <ul className="channels-grid" aria-label="Canales con automatización habitual">
          {channels.primary.map((item) => (
            <ChannelCard key={item.id} item={item} />
          ))}
        </ul>

        <div className="channels-console">
          <p className="channels-kicker channels-kicker--secondary">También en la consola</p>
          <p className="channels-note">
            Puedes registrar estos canales desde el panel; en la demo confirmamos el nivel de automatización
            según tu caso.
          </p>
          <ul className="channels-grid channels-grid--console" aria-label="Canales adicionales en consola">
            {channels.alsoInConsole.map((item) => (
              <ChannelCard key={item.id} item={item} compact />
            ))}
          </ul>
        </div>
      </ScrollReveal>
    </Section>
  );
}
